import { useSelector } from 'react-redux';

import PropTypes from 'prop-types';

import { EM_DASH } from 'constants/ui';

import { selectExtendedUsers } from 'store/users/selectors';

const InitiatedByCell = ({ userId = null }) => {
  const users = useSelector(selectExtendedUsers);

  return (userId && users[userId]?.name) || EM_DASH;
};

InitiatedByCell.propTypes = {
  userId: PropTypes.string,
};

export default InitiatedByCell;
